import React from 'react';
import MetricaBase from './MetricaBase';

const MetricaTempoEmpresa = () => {
  return (
    <MetricaBase
      titulo="Tempo de Empresa"
      descricao="Análise da distribuição de colaboradores ativos por tempo de empresa"
      endpoint="tempo-empresa"
      tipoDownload="tempo-empresa"
      cor="indigo"
    />
  );
};

export default MetricaTempoEmpresa;